import * as xlsx from 'xlsx';
import { supabase } from '@/core/database/supabase';
import type { InventoryItem } from '../types/inventoryList.types';

export const inventoryExcelService = {
  exportToExcel(items: InventoryItem[], filename = 'Danh_sach_vat_tu.xlsx') {
    const data = items.map(item => ({
      'Mã vật tư': item.code,
      'Tên vật tư': item.name,
      'Nhóm vật tư': item.category_name || 'Khác',
      'Đơn vị tính': item.unit,
      'Tồn kho': item.current_stock,
      'Giá nhập': item.unit_price,
      'Giá trị tồn': item.current_stock * item.unit_price,
      'Trạng thái': item.status_code,
      'Nhà cung cấp': item.supplier_name || '',
      'Kho': item.warehouse_name || '',
      'Ghi chú': item.note || ''
    }));

    const worksheet = xlsx.utils.json_to_sheet(data);
    
    // Auto-fit columns
    const wscols = [
      { wch: 15 }, // Mã vật tư
      { wch: 30 }, // Tên vật tư
      { wch: 20 }, // Nhóm vật tư
      { wch: 10 }, // Đơn vị tính
      { wch: 10 }, // Tồn kho
      { wch: 15 }, // Giá nhập
      { wch: 15 }, // Giá trị tồn
      { wch: 15 }, // Trạng thái
      { wch: 20 }, // Nhà cung cấp
      { wch: 20 }, // Kho
      { wch: 30 }, // Ghi chú
    ];
    worksheet['!cols'] = wscols;

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Vật tư');
    xlsx.writeFile(workbook, filename);
  },

  async importFromExcel(file: File, companyId: string): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = e.target?.result;
          const workbook = xlsx.read(data, { type: 'binary' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = xlsx.utils.sheet_to_json<Record<string, any>>(worksheet);

          const insertData = jsonData.map(row => ({
            company_id: companyId,
            code: row['Mã vật tư'] || row.code || `VT-${Math.random().toString(36).substr(2, 5).toUpperCase()}`,
            name: row['Tên vật tư'] || row.name || 'Vật tư chưa đặt tên',
            category_name: row['Nhóm vật tư'] || row.category_name,
            unit: row['Đơn vị tính'] || row.unit || 'Cái',
            current_stock: Number(row['Tồn kho'] || row.current_stock || 0),
            unit_price: Number(row['Giá nhập'] || row.unit_price || 0),
            supplier_name: row['Nhà cung cấp'] || row.supplier_name,
            warehouse_name: row['Kho'] || row.warehouse_name,
            note: row['Ghi chú'] || row.note,
          }));

          if (insertData.length === 0) return resolve(0);

          const { error } = await supabase
            .from('inventory_items')
            .insert(insertData);

          if (error) throw error;
          resolve(insertData.length);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsBinaryString(file);
    });
  }
};
